import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormControl, Validators } from '@angular/forms';

@Component({
  selector: 'app-file-import-dialog',
  templateUrl: './file-import-dialog.component.html',
  styleUrls: ['./file-import-dialog.component.scss']
})
export class FileImportDialogComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<FileImportDialogComponent>) {
    dialogRef.disableClose = true;
  }
  fileContent: string = "";
  button1: string = "Cancel";
  button2: string = "Import";
  title: string = "Import CSV File";
  deleteTravelMixes: boolean = true;
  isImportButtonDisabled: boolean = true;

  ngOnInit() {
  }
  openFile(event) {
    let input = event.target;
    for (var index = 0; index < input.files.length; index++) {
      let reader = new FileReader();
      reader.onload = () => {
        var text = reader.result;
        this.fileContent = text.toString();
        if (this.fileContent.length > 0) {
          this.isImportButtonDisabled = false;
        }
      }
      reader.readAsText(input.files[index], 'ASCII');
    };
  }
  importFile() {
    if (this.fileContent !== null) {
      this.dialogRef.close({ save: true, data: { fileContent: this.fileContent, deleteTravelMixes: this.deleteTravelMixes } });
    }
  }
  cancel() {
    this.dialogRef.close({ save: false, data: null });
  }


}
